import { Middleware } from '@nuxt/types';

const enforceMassEmailsGate: Middleware = context => {
  const withMassEmails = context.store.getters['events/withMassEmails'];
  if (!withMassEmails) {
    const errorMessage = context.app.i18n.t('shared.error.server_validation.authorization_error');
    context.app.$toast.error(errorMessage);
    context.$auth.redirect('home');
  }
};

export default enforceMassEmailsGate;
